module.exports = __webpack_public_path__ + "img/logo.416c5404.png";